export default {
  newsList: (state) => state.newsList.list,
  newsCount: (state) => state.newsList.count,
  newsDetail: (state) => state.newsDetail,
  sortText: (state) => state.sortText,
  sortType: (state) => state.sortType,
};
